<template>
  <transition name="fade">
    <div class="full-screen-modal">
      <div is="style" scoped="scoped">
        {{ mobileCSS }}
        {{ cssClass }}
      </div>
      <div id="menu" class="menu">
        <h1>プレビュー</h1>
        <!-- メッセージ表示 -->
        <div class="toast-box">
          <transition name="fade">
            <div
              v-if="isShowBasicInfo && showMessageToast"
              :class="{'toast-success': toastSuccessClass, 'toast-error': toastErrorClass}"
            >
              <span>{{ $store.state.status.messageToasts[0].message }}</span>
            </div>
          </transition>
        </div>
        <div id="mode-selector" class="mode-selector">
          <ul class="mode-selector-tab">
            <li
              class="normal-btn"
              :class="{ selected : !isMobile }"
              @click="changePreviewDevice(false)"
            >
              DeskTop
            </li>
            <li
              class="normal-btn"
              :class="{ selected : isMobile }"
              @click="changePreviewDevice(true)"
            >
              Mobile
            </li>
          </ul>
        </div>
        <div class="close-btn" @click="onClose" data-shortcut-esc="htmlPreview"><span></span></div>
      </div>
      <multipane
        :class="{'enable-multipane': isShowBasicInfo}"
        @paneResizeStart="isShowMasker = true"
        @paneResizeStop="isShowMasker = false"
        layout="vertical"
      >
        <!-- 左側：プレビュー -->
        <div class="html-preview" align="center">
          <!-- iframe上はmultipaneのマウスイベントが拾えないので、ドラッグ中だけ透明なものを表示する -->
          <div v-if="isShowMasker" class="masker"/>
          <div v-if="isMobile" class="mobile">
            <span class="browser header"></span>
            <div v-if="isShowMasker" class="masker"/>
            <iframe
              id="iframe"
              :width="displayWidth"
              :height="displayMobileHeight"
              align="middle"
              :srcdoc="mailing"
            />
            <span class="browser footer"></span>
          </div>
          <div v-else>
            <iframe
              id="iframe"
              width="100%"
              :height="displayHeight"
              align="middle"
              :srcdoc="mailing"
            />
          </div>
        </div>
        <multipane-resizer v-if="isShowBasicInfo"/>
        <!-- 右側：基本情報 -->
        <div class="pane-basic-info" v-if="isShowBasicInfo">
          <content-basic-info :enableOwnSave="true"/>
        </div>
      </multipane>
    </div>
  </transition>
</template>

<script>
import base from '@/components/Content/Check/ContentCheckBase'
import ShortCutBase from '@/mixins/ShortCutBase'
import ContentBasicInfo from '@/components/Content/Palette/ContentBasicInfo'
import { Multipane, MultipaneResizer } from 'vue-multipane'

export default {
  name: 'html-preview',
  mixins: [
    base,
    ShortCutBase,
  ],
  props: [
    'isShowBasicInfo',
  ],
  components: {
    ContentBasicInfo,
    Multipane,
    MultipaneResizer,
  },
  data () {
    return {
      isShowMasker: false,
      mobileCSS: '',
      cssClass: '',
      rawHTML: '',
      mailing: '',
      displayHeight: '',
      displayMobileHeight: '',
      displayWidth: this.$store.getters.noUnitScssVars.HTMLPreviewDefaultWidth,
      isMobile: false,
    }
  },
  computed: {
    showMessageToast () {
      return this.$store.state.status.messageToasts.length > 0
    },
    toastSuccessClass () {
      return this.$store.state.status.messageToasts[0].kind === 'success'
    },
    toastErrorClass () {
      return this.$store.state.status.messageToasts[0].kind === 'error'
    },
  },
  created () {
    this.getMailing()
  },
  mounted () {
    this.$nextTick(() => {
      this.changePreviewSize()
      this.setDisplayHeight()
      this.getCssClass()
    })
  },
  methods: {
    onClose () {
      this.$emit('close')
    },
    getMailing () {
      // PHP 側で style タグまで含めたメーリングを取得する。
      this.mobileCSS = this.createMobileCSS()
      this.createRawHTML()
      const formData = new FormData()
      formData.append('body', this.rawHTML)
      // title
      formData.append('title', this.$store.getters.getContentInfo.name)
      // モバイルスタイルCSS
      if (this.mobileCSS) formData.append('mobileCss', this.mobileCSS)
      // メール用CSS
      formData.append('headCss', this.createHeadCSS())
      // outlook CSS
      formData.append('outlookCss', this.createOutlookCSS())

      this.$http({
        type: 'POST',
        url: '/content/html_preview',
        params: formData,
      }).then(json => {
        if (json && json.status === 200) {
          this.mailing = json.data.html
        }
      })
    },
    getCssClass () {
      const mobileFrameLineWeight = 15
      const mobileFrameHeight = parseInt(this.displayMobileHeight * 1.15)
      // モバイルのスクリーン外側の高さ = フレーム(全体) - 表示部分 - 枠上下
      const mobileScreenOutsideHeight = mobileFrameHeight - this.displayMobileHeight - mobileFrameLineWeight * 2
      this.cssClass = `
        .mobile {
          position: relative;
          pointer-events: auto;
          padding: 10px 0;
        }
        .mobile iframe {
          border-left: 1px solid #797473;
          border-right: 1px solid #797473;
          position: absolute;
          top: ${mobileScreenOutsideHeight + 5}px;
          left: 50%;
          transform: translateX(-50%);
        }
        .mobile::before {
          content: '';
          border: ${mobileFrameLineWeight}px solid #797473;
          width: 375px;
          height: ${mobileFrameHeight}px;
          border-radius: 50px;
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
          pointer-events: none;
        }
        .mobile::after {
          content: '';
          background: #797473;
          width: 188px;
          height: 40px;
          border-radius: 0 0 25px 25px;
          position: absolute;
          top: 10px;
          left: 50%;
          transform: translateX(-50%);
        }
        .mobile .browser {
          display: block;
          width: 375px;
          height: ${mobileScreenOutsideHeight}px;
          border-radius: 35px 35px 0 0;
          background: #F8F8F8;
          border-bottom: #dbdbdb 1px solid;
        }
        .mobile .browser.footer {
          border-radius: 0 0 25px 25px;
          border-bottom: 0;
          border-top: #dbdbdb 1px solid;
          margin-top: -7px;
        }`
    },
    changePreviewDevice (bool) {
      this.isMobile = bool
      this.changePreviewSize()
    },
    changePreviewSize () {
      if (this.isMobile) {
        this.displayWidth = this.$store.getters.noUnitScssVars.HTMLPreviewMobileWidth
      } else {
        this.displayWidth = this.$store.getters.noUnitScssVars.HTMLPreviewDefaultWidth
      }
    },
    setDisplayHeight () {
      this.displayMobileHeight = parseInt((document.documentElement.scrollHeight - document.getElementById('menu').clientHeight) * 4 / 5)
      this.displayHeight = document.documentElement.scrollHeight - document.getElementById('menu').clientHeight
    },
  },
}
</script>

<style lang="scss" scoped>
// 編集ページ
.full-screen-modal {
  overflow-y: hidden;
  // リサイズ可能なペインをラップするクラス
  .menu {
    height: $navbarHeight;
    line-height: $navbarHeight;
    padding-left: 20px;
    color: #fff;
    font-size: 24px;
    background: $primaryMenuColor;
    position: fixed;
    width: 100%;
    z-index: 2;
    .toast-box {
      min-width: 100px;
      position: fixed;
      top: 20px;
      right: 380px;
      .fade-enter-active {
        transition: opacity 0.1s;
      }
    }
    .mode-selector {
      .mode-selector-tab {
        color: $commonFontColor;
        position: absolute;
        top: 0;
        right: 100px;
        li {
          width: 120px;
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          display: inline-block;
          color: rgba(#fff, 0.3);
          padding: 0;
          &:first-of-type {
            margin-right: 40px;
            position: relative;
            &::after {
              content: '';
              width: 0.5px;
              height: 40px;
              background: rgba(#fff, 0.1);
              position: absolute;
              top: 0;
              right: -20px;
            }
          }
          &:hover {
            background: rgba(#fff, 0.2);
            transition: all 0.3s ease 0s;
          }
          &.selected {
            color: $commonFontColor;
            background: rgba(#fff, 0.7);
          }
        }
      }
    }
    .close-btn {
      top: 7px;
    }
  }
  .pane {
    height: calc(100vh - #{$defaultTopMargin} - #{$navbarHeight});
    // 左側：プレビュー
    .html-preview {
      width: $previewHTMLWidth;
    }
  }
}

.multipane {
  display: block;
  margin-top: $navbarHeight;
}

.enable-multipane {
  display: flex;
  height: 100%;
  .html-preview {
    width: calc(100vw - #{$paletteWidth});
    height: 100%;
    .masker {
      opacity: 0;
      position: absolute;
      width: 100%;
      height: 100%;
    }
    position: relative;
    overflow: hidden;
    .white-wrap {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: #fff;
      opacity: 0;
      transition: all 0.5s ease 0s;
      visibility: hidden;
      &.loading {
        opacity: 1;
        visibility: visible;
      }
    }
  }
  .pane-basic-info {
    width: calc(100vw - #{$previewWidth});
    flex-grow: 1; // これを外すと、パレットのドラッグで幅変更が動かなくなるので必要
    overflow-y: auto; // これを外すと、パレットの縦スクロールが効かなくなるので必要
    background: #F8F8F8;
    border-left: 0.5px solid #dbdbdb;
  }
}
</style>
